import React, { useState } from 'react';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

const ReferUsage = () => {


    // Mock logged-in user
    const loggedInUser = {
        id: 1,
        fullName: "John Doe",
    };

    // Mock referral usage data
    const mockReferralData = [
        {
            referrerId: 1,
            referredUserId: 101,
            referredUserEmail: "alice@example.com",
            usageDate: "2025-09-10 14:32",
            rewardType: "amount",
            rewardValue: 100,
        },
        {
            referrerId: 1,
            referredUserId: 102,
            referredUserEmail: "bob@example.com",
            usageDate: "2025-09-12 10:15",
            rewardType: "percentage",
            rewardValue: 15,
        },
        {
            referrerId: 2,
            referredUserId: 103,
            referredUserEmail: "charlie@example.com",
            usageDate: "2025-09-11 18:45",
            rewardType: "amount",
            rewardValue: 50,
        },
    ];

    const [referralData, setReferralData] = useState(mockReferralData);
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;
    const totalPages = Math.ceil(referralData.length / rowsPerPage);

    const paginatedData = referralData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    // Format reward display
    const getFormattedReward = (row) =>
        row.rewardType === "amount" ? `₹${row.rewardValue}` : `${row.rewardValue}%`;

    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Referral Usage</h1>
            </div>

            {/* Desktop Table */}
            <div className="customer-table responsive-table">
                <table>
                    <thead>
                        <tr>
                            <th>Referrer ID</th>
                            <th>Referred ID</th>
                            <th>Referred Email</th>
                            <th>Reward</th>
                            <th>Usage Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedData.length > 0 ? (
                            paginatedData.map((row, i) => (
                                <tr key={i}>
                                    <td>{row.referrerId}</td>
                                    <td>{row.referredUserId}</td>
                                    <td>{row.referredUserEmail}</td>
                                    <td>{getFormattedReward(row)}</td>
                                    <td>{row.usageDate}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                    No referral usage yet.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Mobile Cards */}
            <div className="ecom-responsive-cards">
                {paginatedData.length > 0 ? (
                    paginatedData.map((row, i) => (
                        <div className="ecom-responsive-card" key={i}>
                            <div className="ecom-responsive-header">
                                <p>
                                    <strong className='mr-1'>Usage Date:</strong> {row.usageDate}
                                </p>
                            </div>
                            <div className="ecom-responsive-body">
                                <p>
                                    <strong>Referrer ID:</strong> {row.referrerId}
                                </p>
                                <p>
                                    <strong>Referred User ID:</strong> {row.referredUserId}
                                </p>
                                <p>
                                    <strong>Email:</strong> {row.referredUserEmail}
                                </p>
                                <p>
                                    <strong>Reward:</strong> {getFormattedReward(row)}
                                </p>
                            </div>
                        </div>
                    ))
                ) : (
                    <p style={{ textAlign: "center", margin: "50px" }}>
                        No referral usage yet
                    </p>
                )}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="pagination">
                    <button
                        onClick={() => handlePageChange(1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronsLeft size={18} />
                    </button>
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronLeft size={18} />
                    </button>
                    <button className="pagination-btn active">{currentPage}</button>
                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronRight size={18} />
                    </button>
                    <button
                        onClick={() => handlePageChange(totalPages)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronsRight size={18} />
                    </button>
                </div>
            )}
        </>
    );
};

export default ReferUsage;
